import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Local mock mode (`npm run start:mock`, src/mocks/index.js), on the dev server only. The
// NODE_ENV test comes first because webpack can resolve it: in a production build the
// condition is a constant false and the mocks are left out of the bundle. (An unset
// REACT_APP_* key alone is not enough: CRA defines process.env as an object, so webpack
// cannot tell that it is missing and would keep the require.)
if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_MOCK_API === '1') {
  // eslint-disable-next-line global-require
  require('./mocks').installMocks();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
